// @flow
import React from 'react';
import { token } from '@atlaskit/tokens';
import styled from 'styled-components';
import { SubHeader } from 'modules/checkout/styled';

type Props = {
  isSelected: boolean,
  select: () => void,
  title: React.Node,
  children: any,
  testId: string,
};

const Wrapper = styled.div`
  padding: 18px;
  outline: none;
  cursor: pointer;

  &:first-child {
    border-radius: 4px 0 0 0;
  }

  ${(props) =>
    props.isSelected
      ? `
    background: ${token('color.background.information', '#E9F2FF')};
    border: 1px solid ${token('color.icon.information', '#579DFF')};
    margin: -1px;  
    position: relative;
    
    &::after {
      content: "";
      border-bottom: none;
      border-left: none;
      border-top: 1px solid ${token('color.icon.information', '#579DFF')};
      border-right: 1px solid ${token('color.icon.information', '#579DFF')};
      width: 16px;
      height: 18px;
      line-height: 16px;
      right: -9px;
      top: 0;
      margin-top: auto;
      margin-bottom: auto;
      bottom: 0;
      background: ${token('color.background.information', '#E9F2FF')};
      position: absolute;
      transform: rotate(46grad);
    }`
      : `
    background: ${token('color.background.neutral', '#F1F2F4')};
    border-bottom: 1px solid ${token('color.border.disabled', '#8590A2')};
  `}
`;

const Description = styled.p`
  color: ${token('color.text', '#172B4D')};
  font-size: 13px;
`;

export default (props: Props) => (
  <Wrapper
    data-testid={props.testId}
    isSelected={props.isSelected}
    onClick={() => !props.isSelected && props.select()}
  >
    <SubHeader>{props.title}</SubHeader>
    <Description>{props.children}</Description>
  </Wrapper>
);
